import { Anchor } from '@common';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type ContextLinkActionPropsType = {
  to: string | null;
  disabled?: boolean;
};

export const ContextLinkAction: React.FC<ContextLinkActionPropsType> = ({
  to,
  disabled = false,
}) => {
  const { t } = useTranslation('tasks');
  const label = t('ACTIONS.OPEN_CONTEXT');

  return (
    <Tooltip label={label}>
      <span
        style={{
          display: 'inline-flex',
          opacity: disabled ? 0.4 : undefined,
          cursor: disabled ? 'not-allowed' : undefined,
        }}
      >
        {disabled || !to ? (
          <span aria-label={label} aria-disabled="true">
            <FontAwesomeIcon icon={faArrowRight} />
          </span>
        ) : (
          <Anchor to={to} aria-label={label} c="inherit">
            <FontAwesomeIcon icon={faArrowRight} />
          </Anchor>
        )}
      </span>
    </Tooltip>
  );
};
